export default {
  停车场收费管理系统:
    '//work.ecaray.com/gw/parking_fee.html#hw_status=5&CSUM=1',
  停车经营: '//work.ecaray.com/gw/operation.html#hw_status=5&CSUM=1',
  启航系列: '//work.ecaray.com/gw/sail.html#hw_status=5&CSUM=1',
  城市道路停车: '//work.ecaray.com/gw/hardware.html#hw_status=1&CSUM=1',
  智能硬件: '//work.ecaray.com/gw/hardware.html#hw_status=1&CSUM=1',
  蜜蜂停车: '//work.ecaray.com/gw/parkbees.html#hw_status=5&CSUM=1',
  领航系列: '//work.ecaray.com/gw/navigation.html#hw_status=5&CSUM=1',
  首页: '//work.ecaray.com/gw/index.html#hw_status=1&CSUM=1',
  封闭式停车场: '//work.ecaray.com/gw/hardware.html#hw_status=2&CSUM=1',
  新能源充电桩: '//work.ecaray.com/gw/hardware.html#hw_status=3&CSUM=1',
  城市诱导系统: '//work.ecaray.com/gw/hardware.html#hw_status=4&CSUM=1',
  城市总控中心: '//work.ecaray.com/gw/hardware.html#hw_status=5&CSUM=1',
  开放平台: '//work.ecaray.com/gw/open_platform.html#hw_status=5&CSUM=1',
  车主服务: '//work.ecaray.com/gw/car_owner_service.html',
};
